import StageTwo from "./component";
import StageTwoContainer from "./container";

export { StageTwo, StageTwoContainer };
export default StageTwoContainer;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/StageTwo/index.ts